<template>
  <div>

    <div class="container mx-auto py-5 px-4">
      <div class="flex mb-5 " v-if="themeBanner">
        <img :src="themeBanner" loading="lazy" class=" rounded-3xl w-full" />
      </div>
      <div class="flex justify-between gap-10 py-7 flex-col lg:flex-row">
        <div class="flex flex-col text-center col-description lg:text-left mx-auto lg:m-0">
          <h2 class="section-title">Ibahagi ang inyong mga litrato</h2>
          <p class="section-description pt-3">
            Nais naming makita ang pagdiriwang na ito sa inyong punto de vista. <br>
            I-scan ang QR Code at i-upload ang inyong mga litrato <br>
            upang makita ng lahat sa ating LED Wall
          </p>
        </div>

        <div class="flex justify-end flex-col md:flex-row gap-2 flex-nav shrink-0 items-start">
          <Button class="btn-gallery" :disabled="topQueue.length === 0" label="Live Gallery" @click.prevent="openSlideShow">
            <template #icon>
              <i class="icon mr-2">wallpaper_slideshow</i>
            </template>
          </Button>
          <Uploader></Uploader>
          <Button class="btn-history" label="Your Uploads" @click.prevent="openUploads" v-if="hasUploads">
            <template #icon>
              <i class="icon mr-2">history</i>
            </template>
          </Button>
        </div>
      </div>



      <masonry-wall class="masonry-wall" :items="topQueue" :column-width="300" :gap="16">
        <template #default="{ item, index }">
          <template v-if="isImage(item.type)">
            <Image preview>
              <template #image>
                <img :src="item.thumb" :alt="item.public_id" loading="lazy" />
              </template>
              <template #preview="slotProps">
                <img :src="item.url" alt="preview" :style="slotProps.style" @click="slotProps.onClick" :alt="item.public_id" />
              </template>
              <template #indicatoricon>
                <i class="icon">visibility</i>
              </template>
            </Image>
          </template>
          <template v-else-if="isVideo(item.type)">
            <Image preview class="has-video">
              <template #image>
                <img :src="item.thumb" :alt="item.public_id" loading="lazy" />
              </template>
              <template #preview="slotProps">
                <iframe :src="`https://player.cloudinary.com/embed/?cloud_name=${config.public.CLOUD_API_NAME}&public_id=${item.public_id}&player[muted]=false&player[autoplayMode]=on-scroll&player[autoplay]=true`" width="640" height="360" style="height: 80vh; width: auto; aspect-ratio: 640 / 360;" allow="autoplay; fullscreen; encrypted-media; picture-in-picture" allowfullscreen frameborder="0"></iframe>
              </template>
              <template #indicatoricon>
                <i class="icon">play_arrow</i>
              </template>
            </Image>
          </template>
        </template>
      </masonry-wall>

      <Toast />
    </div>
  </div>
</template>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-in-out;
  /* transition: opacity 0.5s; */
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
<script setup>
import { computed, onMounted } from 'vue';
import NProgress from 'nprogress'
import '../node_modules/nprogress/nprogress.css'
import Header from "~/components/Header.vue"

const supabase = useSupabaseClient()

const config = useRuntimeConfig();

NProgress.configure({ showSpinner: false });

import Button from 'primevue/button';
import Image from 'primevue/image';
const themeBanner = config.public.THEME_BANNER;
const themeLogo = config.public.THEME_LOGO;
const queue = ref([]);
const topLength = ref(1000);
const topQueue = computed(() => {
  const sortedArray = [...queue.value].sort((a, b) => a.created_at - b.created_at);
  const reversedArray = sortedArray.reverse();
  const top10 = reversedArray.slice(0, topLength.value);
  return top10;
});

const files = ref([]);
const uploadStore = ref([])

const hasUploads = computed(() => uploadStore && uploadStore.value.length > 0);

const openUploads = async () => {
  await navigateTo('/uploads')
}

const openSlideShow = async () => {
  await navigateTo('/gallery')
}

const isImage = (type) => {
  return type.startsWith('image/');
}

const isVideo = (type) => {
  return type.startsWith('video/');
}

const onUploadEvent = (payload) => {
  console.log('Upload Event', payload);

  if (payload.eventType === 'INSERT') {
    const file = payload.new;
    queue.value.push(file);

    refreshLocalStore();
  }

  if (payload.eventType === 'DELETE') {
    deleteFromList(payload.old.id);
  }

}

function deleteFromList(id) {

  const index = files.value.findIndex(item => item['id'] === id);
  if (index !== -1) {
    files.value.splice(index, 1);
  }

  const queueIndex = queue.value.findIndex(item => item['id'] === id);
  if (queueIndex !== -1) {
    queue.value.splice(queueIndex, 1);
  }

  const localStore = JSON.parse(localStorage.getItem('wedding-photo-app')) || [];

  const localStoreIndex = localStore.findIndex(item => item['id'] === id);

  if (localStoreIndex !== -1) {
    localStore.splice(localStoreIndex, 1);
    localStorage.setItem('wedding-photo-app', JSON.stringify(localStore));
  }

}

const refreshLocalStore = async () => {
  if (typeof localStorage === 'undefined') return;

  uploadStore.value = JSON.parse(localStorage.getItem('wedding-photo-app')) || [];
}

const listenToUploads = () => {
  supabase.channel('uploads-channel')
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: config.public.SPB_TABLE },
      onUploadEvent
    )
    .subscribe()
}

const refreshQueue = async () => {
  queue.value = [...files.value];
}

const getAllUploaded = async () => {
  try {
    const { data, error } = await supabase.from(config.public.SPB_TABLE).select('*')
      .order('created_at');

    if (error) {
      console.error('Error fetching rows:', error);
    } else {

      if (data) {

        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            files.value.push(data[key]);
          }
        }

        await refreshQueue();
      }
    }
  } catch (error) {
    console.error('An error occurred:', error);
  }
}

const checkCodeParameter = async () => {
  if (!window) return;
  const currentURL = new URL(window.location.href);
  const codeParam = currentURL.searchParams.get('code');

  if (codeParam) {
    // Construct the new URL with all existing parameters
    const newURL = '/confirm' + currentURL.search;

    // Perform the redirection
    window.location.href = newURL;
  }
};

onMounted(async () => {
  await checkCodeParameter();
  await refreshLocalStore();
  await getAllUploaded();
  listenToUploads();
});

</script>